(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["25-8-editorial-footer"] && !Shopify.designMode) return;
  try {
    
(function(){
  function fitFooterTitles(){
    document.querySelectorAll('[data-fit-title], .studio-support__hero h1').forEach(function(el){
      el.style.whiteSpace='nowrap'; el.style.wordBreak='normal'; el.style.overflowWrap='normal'; el.style.hyphens='none'; el.style.fontSize='';
      var size=parseFloat(window.getComputedStyle(el).fontSize);
      while(el.scrollWidth>el.clientWidth+1 && size>11){ size-=1; el.style.fontSize=size+'px'; }
    });
  }
  fitFooterTitles(); window.addEventListener('resize',fitFooterTitles);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["25-8-service-center"] && !Shopify.designMode) return;
  try {
    
(function(){
  function fitTitles(){
    document.querySelectorAll('[data-fit-title], .studio-support__hero h1').forEach(function(el){
      el.style.fontSize = '';
      var size = parseFloat(window.getComputedStyle(el).fontSize);
      while (el.scrollWidth > el.clientWidth + 1 && size > 12) { size -= 1; el.style.fontSize = size + 'px'; }
    });
  }
  fitTitles();
  window.addEventListener('resize', fitTitles);

  function initializeBrief() {
    var form = document.getElementById('DesignBriefForm');
    if (!form || form.dataset.briefReady === 'true') return;
    var steps = Array.from(form.querySelectorAll('[data-form-step]'));
    var progress = Array.from(form.querySelectorAll('[data-step-jump]'));
    var next = form.querySelector('[data-brief-next]');
    var back = form.querySelector('[data-brief-back]');
    var submit = form.querySelector('[data-brief-submit]');
    if (!steps.length || !next || !back || !submit) return;
    form.dataset.briefReady = 'true';
    form.noValidate = true;
    var current = 0;

    function show(index, scroll) {
      current = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach(function(step, i) {
        step.hidden = i !== current;
        step.classList.toggle('is-active', i === current);
      });
      progress.forEach(function(button, i) {
        button.classList.toggle('is-active', i <= current);
        if (i === current) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
      back.hidden = current === 0;
      next.hidden = current === steps.length - 1;
      submit.hidden = current !== steps.length - 1;
      if (scroll) steps[current].scrollIntoView({behavior: 'smooth', block: 'start'});
    }

    function firstInvalid(index) {
      var fields = Array.from(steps[index].querySelectorAll('input, select, textarea'));
      return fields.find(function(field) {
        if (field.required && field.type !== 'checkbox' && field.type !== 'radio' && !field.value.trim()) {
          field.setCustomValidity('Please complete this field.');
        } else field.setCustomValidity('');
        var valid = field.checkValidity();
        if (valid) field.removeAttribute('aria-invalid');
        else field.setAttribute('aria-invalid', 'true');
        return !valid;
      });
    }

    function validateThrough(last) {
      for (var i = 0; i <= last; i++) {
        var invalid = firstInvalid(i);
        if (invalid) {
          show(i, true);
          invalid.focus();
          invalid.reportValidity();
          return false;
        }
      }
      return true;
    }

    function clearError(event) {
      var field = event.target;
      if (typeof field.setCustomValidity !== 'function') return;
      field.setCustomValidity('');
      field.removeAttribute('aria-invalid');
    }
    form.addEventListener('input', clearError);
    form.addEventListener('change', clearError);
    next.addEventListener('click', function() { if (validateThrough(current)) show(current + 1, true); });
    back.addEventListener('click', function() { show(current - 1, true); });
    progress.forEach(function(button, index) {
      button.addEventListener('click', function() {
        if (index <= current || validateThrough(index - 1)) show(index, true);
      });
    });
    form.addEventListener('submit', function(event) {
      if (!validateThrough(steps.length - 1)) event.preventDefault();
    });
    show(0, false);
  }
  initializeBrief();
  document.addEventListener('shopify:section:load', function() { fitTitles(); initializeBrief(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
